package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

enum class TimePeriod(val label: String, val key: String) {
    Week("Week", "week"),
    Month("Month", "month"),
    Year("Year", "year");

    companion object {
        fun fromKey(key: String): TimePeriod =
            entries.firstOrNull { it.key.equals(key, ignoreCase = true) } ?: Year
    }
}

@Composable
fun TimeSwitcher(
    activePeriod: TimePeriod = TimePeriod.Year,
    onPeriodSelected: (TimePeriod) -> Unit = {}
) {
    val sportColors = LocalSportColors.current
    val t = LocalAppStrings.current
    fun periodLabel(period: TimePeriod): String = when (period) {
        TimePeriod.Week -> t.navWeek
        TimePeriod.Month -> t.navMonth
        TimePeriod.Year -> t.navYear
    }

    Box(
        modifier = Modifier.styleModifier {
            property("position", "relative")
        }
    ) {
        // Gradient border layer
        Box(
            modifier = Modifier
                .fillMaxSize()
                .styleModifier {
                    property("position", "absolute")
                    property("inset", "0")
                    property("border", "0.3px solid transparent")
                    property("border-radius", s(34))
                    property("background", "${AppGradients.ButtonBorderGradientPrimary} border-box")
                    property("-webkit-mask", "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)")
                    property("mask", "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)")
                    property("-webkit-mask-composite", "xor")
                    property("mask-composite", "exclude")
                    property("pointer-events", "none")
                }
        )
        // Content
        Row(
            Modifier
                .sBorderRadius(34)
                .sPadding(4)
                .styleModifier {
                    property("background", AppGradients.InteractiveSecondary)
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            TimePeriod.entries.forEach { period ->
                if (period == activePeriod) {
                    Box(
                        Modifier
                            .sHeight(36)
                            .sBorderRadius(22)
                            .backgroundColor(sportColors.primary)
                            .sPadding(8, 26)
                            .cursor(Cursor.Pointer)
                            .onClick { onPeriodSelected(period) },
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            periodLabel(period),
                            modifier = Modifier
                                .bodyLMedium()
                                .color(sportColors.onPrimary)
                        )
                    }
                } else {
                    Box(
                        Modifier
                            .sHeight(36)
                            .sPadding(10, 26)
                            .cursor(Cursor.Pointer)
                            .onClick { onPeriodSelected(period) },
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            periodLabel(period),
                            modifier = Modifier
                                .bodyLMedium()
                                .color(com.arena_web.ui.theme.ThemeVars.Text2)
                        )
                    }
                }
            }
        }
    }
}

/** String-based overload for ViewModels that use string period keys */
@Composable
fun TimeSwitcher(
    activePeriodKey: String,
    onPeriodChanged: (String) -> Unit
) {
    TimeSwitcher(
        activePeriod = TimePeriod.fromKey(activePeriodKey),
        onPeriodSelected = { onPeriodChanged(it.key) }
    )
}
